<template>
  <div>
  <v-card class="transparent elevation-0">
    <v-container container--fluid grid-list-md>
      <v-row>
        <v-col cols="12">
          <h1>BeCool Information</h1>
        </v-col>
      </v-row>
      <v-row justify="space-between" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
        <v-col cols="12" sm="12" md="3">
          <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
        </v-col>

        <v-col cols="12" sm="12" md="2" class="text-center" v-if="editPermission">
          <v-tooltip top color="secondary">
            <template v-slot:activator="{ on }">
              <v-btn class="mx-2" fab dark color="blue lighten-1" @click="newInfo" v-on="on">
                <v-icon dark>add</v-icon>
              </v-btn>
            </template>
            <span>Create a new Infomation</span>
          </v-tooltip>
        </v-col>

      </v-row>
    </v-container>
    <v-divider></v-divider>
    <v-data-table
      :headers="headers"
      :search="search"
      :loading="loading"
      :items="renderedInfo"

    >
      <template v-slot:item="props">
        <tr class="cursor" v-bind:class="{odd: props.index % 2, even: !props.index % 2}" >
          <td style="text-align: center" v-for="(header, index) in headers" :key="index"
              v-if="header.text !== 'Actions'">{{props.item[header.value]}}
          </td>
          <td v-else style="text-align: center">
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-icon color="blue" @click="editRow(props.item)" v-on="on">
                  edit
                </v-icon>
              </template>
              <span>Edit</span>
            </v-tooltip>
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-icon color="red" v-on:click="deleteRow(props.item, $event)" v-on="on" class="pl-1">
                  delete
                </v-icon>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card>

    <v-dialog v-model="editDialog" v-if="displayedItem" width="800px">
      <v-card>
        <v-card-title class="d-flex" style="position: relative" :class="$vuetify.breakpoint.smAndDown ? 'justify-start' : 'justify-center'">
          <h2>{{editedIndex > -1 ? 'Edit Info' : 'New Info'}}</h2>
          <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="editDialog=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row justify="space-around">
            <v-list two-line>
              <v-row justify="center" align="center">
                <v-col cols="12" sm="12" md="6" class="py-0" v-for="(key, index) in Object.keys(displayedItem)" :key="index">
                  <v-list-item>
                    <v-list-item-action>
                      <v-icon color="#00a7d3">{{icons[key]}}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content class="pt-0">
                      <div v-if="!fab">
                        <v-list-item-title>{{capitalizeFirstLetter(key)}}</v-list-item-title>
                        <v-list-item-subtitle v-if="key === 'region'" v-on="on">
                          {{regions.filter((region) => {return region.id === displayedItem[key]})[0].name}}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle v-else v-on="on">
                          {{displayedItem[key]}}
                        </v-list-item-subtitle>
                      </div>
                      <div v-else>
                        <v-form ref="form" v-model="valid" lazy-validation>
                          <div v-if="key === 'region'">
                            <v-select
                              :items="renderedregions"
                              item-value="id"
                              item-text="name"
                              v-model="editedItem[key]"></v-select>                          </div>
                          <div v-else-if="key === 'branch_email' || key === 'ops_email' || key === 'cc_global_email'" >
                            <v-text-field v-model="editedItem[key]"
                                          :label="capitalizeFirstLetter(key)"
                                          :rules="emailRules"
                            ></v-text-field>
                          </div>
                          <div v-else-if="key === 'branch_phone'" >
                            <v-text-field v-model="editedItem[key]"
                                          :label="capitalizeFirstLetter(key)"
                                          :rules="phoneRules"
                            ></v-text-field>
                          </div>
                          <div v-else >
                            <v-text-field v-model="editedItem[key]"
                                          :label="capitalizeFirstLetter(key)"
                            ></v-text-field>
                          </div>
                        </v-form>
                      </div>

                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-list>
          </v-row>
          <v-row justify="center" align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
            <v-col md="2" cols="12" class="text-center">
              <v-btn
                text
                @click="editDialog=false;"
                color="blue-grey lighten-2"
              >Cancel
              </v-btn>
            </v-col>
            <v-col md="2" cols="12" class="text-center">
              <v-btn
                text
                @click="saveChanges"
                color="blue darken-1"
              >Save
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteDialog"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title>
          <h3>ATTENTION</h3>
        </v-card-title>
        <v-card-text>
          You are about to delete this information. This action cannot be undone. <br>
          Are you sure you want to proceed ?
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="blue-grey lighten-2" @click="toBeDeleted=null; deleteDialog=false">No</v-btn>
          <v-btn text color="blue darken-1" @click="toggleDelete">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "BecoolInfo",
  data() {
    return {
      search: '',
      loading: false,
      region: null,
      fab: false,
      reload: false,
      editDialog:null,
      editedIndex: -1,
      displayedItem:null,
      toBeDeleted: null,
      deleteDialog: false,
      valid: false,
      isVisible: false,
      default: {
        region:null,
        branch_name: null,
        branch_manager: null,
        branch_phone: null,
        branch_email: null,
        ops_email: null,
        cc_global_email: null,
        warehouse_address: null,
        frozen_facilities:null,
        stock_arrival:null,
        manifest_receipt:null,
      },
      editedItem:{
        region:null,
        branch_name: null,
        branch_manager: null,
        branch_phone: null,
        branch_email: null,
        ops_email: null,
        cc_global_email: null,
        warehouse_address: null,
        frozen_facilities:null,
        stock_arrival:null,
        manifest_receipt:null,
      },
      icons: {
        region:'location_city',
        branch_name: 'location_city',
        branch_manager:'person',
        branch_phone: 'phone_in_talk',
        branch_email: 'smartphone',
        ops_email: 'mail',
        cc_global_email: 'email',
        warehouse_address: 'location_city',
        frozen_facilities:'note',
        stock_arrival:'note',
        manifest_receipt:'note',
      },
      editInfoID:null,
      emailRules:[
        (v) => {
          if (v !== '' && v !== null) {
            if(v.match(/^(([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+([,.](([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+)*$/))
            return true;
            else return 'Invalid Email address (Don \'t put space after the coma if multiple addresses)';
          } else return true;
        },
      ],
      phoneRules:[
        (v) => {
          if (v !== '' && v !== null) {
            if(v.match(/^(\+\d{2}[ \-]{0,1}){0,1}(((\({0,1}[ \-]{0,1})0{0,1}\){0,1}[2|3|7|8]{1}\){0,1}[ \-]*(\d{4}[ \-]{0,1}\d{4}))|(1[ \-]{0,1}(300|800|900|902)[ \-]{0,1}((\d{6})|(\d{3}[ \-]{0,1}\d{3})))|(13[ \-]{0,1}([\d \-]{5})|((\({0,1}[ \-]{0,1})0{0,1}\){0,1}4{1}[\d \-]{8,10})))$/))
              return true;
            else return 'Phone must be valid';
          } else return true;
        }
      ],

    }
  },
  methods:{
    newInfo(){
      this.editedIndex = -1;
      this.displayedItem = Object.assign({}, this.default);
      this.editedItem = Object.assign({}, this.default);
      this.fab = true;
      this.editDialog = true;
    },
    editRow(item) {
      let tem = {
        region:item['region'],
        branch_name: item['branch_name'],
        branch_manager: item['branch_manager'],
        branch_phone: item['branch_phone'],
        branch_email: item['branch_email'],
        ops_email: item['ops_email'],
        cc_global_email: item['cc_global_email'],
        warehouse_address: item['warehouse_address'],
        frozen_facilities:item['frozen_facilities'],
        stock_arrival:item['stock_arrival'],
        manifest_receipt:item['manifest_receipt'],

      };
      this.displayedItem = Object.assign({}, tem);
      this.editedItem = Object.assign({}, this.displayedItem);
      this.editedIndex = this.info.indexOf(item);
      this.editInfoID = item['id'];
      this.fab = true;
      this.editDialog = true;
    },
    deleteRow(item) {
      this.toBeDeleted = item;
      this.deleteDialog = true;
    },
    updateDataTable() {
      this.reload = !this.reload;
    },
    refresh() {
      this.reload = !this.reload;
    },
    saveChanges(){
      let body = this.editedItem;

      if (this.editedIndex > -1) {
        axios.put(process.env.API_URL + '/beccolinfo/' + this.editInfoID, body)
          .then((response) => {
            this.updateDataTable();
            this.$store.commit('displaySnackbar', 'Changes saved.');
          })
          .catch((response) => {
            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
          })
      } else {
        axios.post(process.env.API_URL + '/beccolinfo', body)
          .then((response) => {
            this.updateDataTable();
            this.$store.commit('displaySnackbar', 'info created.');
          })
          .catch((response) => {
            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
          })
      }
      this.editDialog = false;
    },
    toggleDelete(){
      axios.delete(process.env.API_URL + '/beccolinfo/' + this.toBeDeleted.id,)
        .then((response) => {
          this.toBeDeleted = null;
          this.updateDataTable();
          this.$store.commit('displaySnackbar', 'Delete successful');
        })
        .catch((error) => {
          this.$store.commit('displaySnackbar', 'ERROR: Delete failed');
        });
      this.deleteDialog = false;
    },
    capitalizeFirstLetter(string) {
      string = string.replace(/_/g, ' ');
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
  computed: {
    editPermission () {
      return this.$store.getters['auth/hasPermission']('becoolinfo_edit');
    },
    renderedregions(){
      if (this.regions === null || this.regions === undefined) {
        return [];
      } else {
        return this.regions;
      }
    },
    renderedInfo(){
      if (this.info === null || this.info === undefined) {
        return [];
      } else {
        return this.info;
      }
    },
    headers() {
      let headers = [
        {text: 'Branch Name', value: 'branch_name', align: 'center', sortable: true},
        {text: 'Branch Manager', value: 'branch_manager', align: 'center', sortable: true},
        {text: 'Branch Phone', value: 'branch_phone', align: 'center', sortable: false},
        {text: 'Branch Email', value: 'branch_email', align: 'center', sortable: false},
        {text: 'OPS Email', value: 'ops_email', align: 'center', sortable: false},
        {text: 'Global Email', value: 'cc_global_email', align: 'center', sortable: false},
        {text: 'Warehouse Address', value: 'warehouse_address', align: 'center', sortable: false},
        {text: 'Frozen Facilities', value: 'frozen_facilities', align: 'center', sortable: false},
        {text: 'Stock Arrival', value: 'stock_arrival', align: 'center', sortable: false},
        {text: 'Manifest Receipt', value: 'manifest_receipt', align: 'center', sortable: false},
      ];
      if (this.editPermission) headers.push({text: 'Actions', value: 'actions', align: 'center', sortable: false});
      return headers;
    }
  },
  asyncComputed: {
    async regions() {
      if (this.reload || !this.reload) {
        return await axios.get(process.env.API_URL +'/regions')
          .then((response) => {
            if (response.status === 200) {
              return response.data;
            } else {
              return [];
            }
          })
          .catch((error) => {
            return [];
          });
      }
    },
    async info() {
      if (this.reload || !this.reload) {
        this.loading = true;
        return await axios.get(process.env.API_URL +'/beccolinfo')
          .then((response) => {
            this.loading = false;
            if (response.status === 200) {
              return response.data;
            } else {
              return [];
            }
          })
          .catch((error) => {
            this.loading = false;
            return [];
          });
      }
    },
  }
}
</script>

<style scoped>
>>>.v-tabs-bar.v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows):not(.v-slide-group--has-affixes) .v-slide-group__prev {
  display: none!important;
}

.line {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 15px;
  background-color: #6754a8;
}

@keyframes loadingC {
0 {transform: translate(0,0);}
50% {transform: translate(0,15px);}
100% {transform: translate(0,0);}
}

.load-3 .line:nth-last-child(1) {animation: loadingC .6s .1s linear infinite;}
.load-3 .line:nth-last-child(2) {animation: loadingC .6s .2s linear infinite;}
.load-3 .line:nth-last-child(3) {animation: loadingC .6s .3s linear infinite;}

</style>



// WEBPACK FOOTER //
// src/components/pages/Manage/BecoolInfo.vue